module.exports = __webpack_public_path__ + "img/mgh-gotanda-sp@2x.bd90a655.jpg";